import RatingLabel from '@/app/common/filters/surfaces/labels/RatingLabel.tsx';
import EvoRatingLabel from '@/app/common/filters/surfaces/labels/EvoRatingLabel.tsx';
import { FiltersStarsBadgeLabel, FiltersStarsLabel } from '@/app/common/filters/surfaces/labels/FilterStarsLabel.tsx';
import type { CustomLabelComponents } from '@/app/common/filters/core/filtersTypes.ts';
import { FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';
import type { CustomFilterLabelCreators } from '@/app/common/filters/surfaces/forms/FilterGroupsComponents.tsx';

export const CUSTOM_LABEL_COMPONENTS: CustomLabelComponents = {
  rating: RatingLabel,
  ratingEvo: EvoRatingLabel,
  stars: FiltersStarsLabel,
};

// Per-option badge labels: non-evo only, since evo collapses a group into one badge.
export const FILTER_BADGE_LABEL_CREATORS: CustomFilterLabelCreators = {
  [FILTER_NAME.STARS]: FiltersStarsBadgeLabel,
};
